<template>
    <form @submit.prevent="save">
		<form-section label-width="130">

			<control-group title="Dashboard defaults">

                <div class="table-responsive">
                    <table class="table table-grid table-inline table-outer-bordered">
                        <thead>
                            <tr>
                                <th>Dashboard</th>
                                <th>Default user access</th>
                                <th>Default date range</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in dashboards" :key="item.dashboardID">
                                <td>
                                    <a class="text-link" @click="gotoDashboard(item.dashboardID)">{{item.dashboardName}}</a>
                                </td>
                                <td>
                                    <select v-control v-model="item.defaultDashboardPermission">
                                        <option v-if="item.defaultDashboardPermission == null" :value="null">- Choose -</option>
                                        <option
                                            v-for="type in permissionTypes"
                                            :key="type.dashboardPermissionTypeID"
                                            :value="type.dashboardPermissionTypeID"
                                        >
                                            {{type.dashboardPermissionTypeText}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <default-date-range-editor
                                        :date-range="item.defaultDateRange"
                                        :group-by="item.defaultGroupBy"
                                        @change="onDateRangeChange($event, item)"
                                    />
                                </td>
                            </tr>
                            <tr v-if="dashboards && !dashboards.length">
                                <td colspan="99" class="cell-empty">No dashboards found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

			</control-group>

            <control-group inset>
				<btn primary type="submit">Save</btn>
				<btn link>Cancel</btn>
			</control-group>
					
		</form-section>
	</form>
</template>


<script>
    import _ from 'lodash';
    import { AsyncMixin } from 'pdk/mixins';
    import { notifications } from 'pdk/services';
    import { groups } from '@/services';
    import { dashboards } from 'dashboard-pdk/services';
    import { actions as dashboardActions } from 'dashboard-pdk/store';
    import { DefaultDateRangeEditor } from 'dashboard-pdk/components/dashboards';


	export default {
		name: 'group-settings-editor',
        components: {
            DefaultDateRangeEditor
        },
        mixins: [AsyncMixin],
        props: {
            locationGroupId: {
                type: String,
                required: true
            }
        },
		data() {
			return {
                dashboards: undefined,
                permissionTypes: undefined,
                dateRangeTypes: undefined,
                groupByTypes: undefined
			};
        },
        computed: {
            ready() {
                if (!this.dashboards) return false;
                if (!this.permissionTypes) return false;
                if (!this.dateRangeTypes) return false;
                if (!this.groupByTypes) return false;

                return true;
            }
        },
        created() {
            this.getPermissionTypes();
            this.getDashboards();
        },
        methods: {
            gotoDashboard(dashboardID) {
                this.async(this.$store.dispatch(dashboardActions.NAVIGATE_TO_DASHBOARD, {
                    locationGroupID: this.locationGroupId,
                    dashboardID
                }))
                    .then(() => {
                        this.$router.push({
                        name: 'group-dashboards',
                        locationGroupId: this.locationGroupId
                    });
                });
            },
            getDashboards() {
                this.async(groups.getDashboards({
                    locationGroupID: this.locationGroupId
                })).then((dashboardList) => {
                    this.dashboards = dashboardList;
                });
            },
            getPermissionTypes() {
                this.async(dashboards.getDashboardPermissionTypes())
                    .then((types) => {
                        this.permissionTypes = types;
                    });
            },
            save() {
                this.$emit('save');

                this.async(groups.updateDashboards({
                    locationGroupID: this.locationGroupId,
                    dashboards: this.dashboards
                })).then(() => {
                    notifications.open({
                        content: 'Dashboard defaults saved'
                    });
                });
            },

            onDateRangeChange(data, item) {
                item.defaultDateRange = data.dateRange;
                item.defaultGroupBy = data.groupBy;
            }
		}
	};
</script>
